module.exports = __webpack_public_path__ + "static/media/bg.93badef4.svg";